module.exports = __webpack_public_path__ + "img/imagen4.e0325739.png";